import React from 'react'
import { Box, Typography, makeStyles } from '@material-ui/core'
import RichText from '../RichText'
import { isObjectEmpty } from '../../utils/objects'
import { AppIcon, MailtoIcon, TelIcon, WhatsappIcon } from '../SVGIcons'

const getFormattedNumberForLink = (number, isWhatsapp = false) => {
  let numberWithoutSpaces = number.replaceAll(' ', '')
  if (isWhatsapp) numberWithoutSpaces = numberWithoutSpaces.replaceAll('+', '')
  return numberWithoutSpaces
}

// const getFormattedEmailForLink = (email = '') => {
//   return email.replaceAll('@', '[at]').replaceAll('.', '[.]')
// }

const ContactChannels = ({ data }) => {
  const { title, description, channels } = data
  const styles = useStyles()
  return (
    <>
      <Typography variant="h6" className={styles.title}>
        {title}
      </Typography>
      {description && (
        <div className={styles.text}>
          <RichText variant="body1" document={JSON.parse(description.raw)} />
        </div>
      )}
      {!isObjectEmpty(channels) && (
        <Box>
          {channels.whatsapp && (
            <Typography className={styles.channelItem}>
              <WhatsappIcon />
              <a
                href={`https://wa.me/${getFormattedNumberForLink(
                  channels.whatsapp,
                  true,
                )}`}
                target="_blank"
                rel="noreferrer"
              >
                {channels.whatsapp}
              </a>
            </Typography>
          )}
          {channels.tel && (
            <Typography className={styles.channelItem}>
              <TelIcon />
              <a href={`tel:${getFormattedNumberForLink(channels.tel)}`}>
                {channels.tel}
              </a>
            </Typography>
          )}
          {channels.mailto && (
            <Typography className={styles.channelItem}>
              <MailtoIcon />
              <a href={`mailto:${channels.mailto}`}>
                {channels.cc && 'For inquiries:'} {channels.mailto}
              </a>
            </Typography>
          )}
          {channels.cc && (
            <Typography className={styles.channelItem}>
              <MailtoIcon />
              <a href={`mailto:${channels.cc}`}>
                For complaints: {channels.cc}
              </a>
            </Typography>
          )}
          {channels.app && (
            <Typography className={styles.channelItem}>
              <AppIcon />
              <a href="/auto-leasing/after-sales-services">{channels.app}</a>
            </Typography>
          )}
        </Box>
      )}
    </>
  )
}

const useStyles = makeStyles((theme) => ({
  title: {
    margin: theme.spacing(0, 0, 3),
  },
  channelItem: {
    margin: theme.spacing(2, 0),
    display: 'flex',
    alignItems: 'center',
    '& a': {
      marginLeft: theme.spacing(1),
      color: theme.palette.text.primary,
      textDecoration: 'none',
    },
  },
}))

export default ContactChannels
